import { Link } from 'react-router-dom';

import { Button } from '@mui/material';
import { IconLock } from '@tabler/icons';

import useAuth from 'hooks/useAuth';

import AccessStatePage from './accessStatePage';
import SignedInPanel from './signedInPanel';

// ==============================|| NO CLINIC ACCESS PAGE ||============================== //

// Shown in place of any /clinic/:clinicId/... page whose clinic the signed-in
// account has no grant for. The client only knows its own grants, so a clinic
// in another org and a clinic in this org without a grant look the same here;
// the copy names the active org and covers both so the user can tell the two
// apart. Switching org is left to the profile menu.
const NoClinicAccessPage = () => {
    const { organizationMeta } = useAuth();
    const orgName = organizationMeta?.meta?.name || 'this organization';

    return (
        <AccessStatePage
            testId="no-clinic-access-page"
            icon={<IconLock stroke={1.8} size="1.4rem" />}
            title="You don't have access to this clinic"
            body={`This clinic isn't in ${orgName}, or you haven't been added to it. The link may be out of date, or your access may have changed.`}
            actions={
                <Button variant="contained" component={Link} to="/" data-testid="no-clinic-access-home">
                    Go Home
                </Button>
            }
            hint="Wrong organization? Switch from your profile menu in the top right. Otherwise, ask your org admin to add you to this clinic."
            aside={<SignedInPanel />}
        />
    );
};

export default NoClinicAccessPage;
